export const entityData = [
  // Common / Basic
  {
    char: "©",
    name: "&copy;",
    num: "&#169;",
    desc: "Copyright Symbol",
    category: "Common",
  },
  {
    char: "®",
    name: "&reg;",
    num: "&#174;",
    desc: "Registered Trademark",
    category: "Common",
  },
  {
    char: "™",
    name: "&trade;",
    num: "&#8482;",
    desc: "Trademark Symbol",
    category: "Common",
  },
  {
    char: "&",
    name: "&amp;",
    num: "&#38;",
    desc: "Ampersand",
    category: "Common",
  },
  {
    char: "<",
    name: "&lt;",
    num: "&#60;",
    desc: "Less Than",
    category: "Common",
  },
  {
    char: ">",
    name: "&gt;",
    num: "&#62;",
    desc: "Greater Than",
    category: "Common",
  },
  {
    char: '"',
    name: "&quot;",
    num: "&#34;",
    desc: "Double Quote",
    category: "Common",
  },
  {
    char: "'",
    name: "&apos;",
    num: "&#39;",
    desc: "Single Quote",
    category: "Common",
  },
  {
    char: " ",
    name: "&nbsp;",
    num: "&#160;",
    desc: "Non-Breaking Space",
    category: "Common",
  },

  // Currency
  {
    char: "$",
    name: "&dollar;",
    num: "&#36;",
    desc: "Dollar Sign",
    category: "Currency",
  },
  {
    char: "€",
    name: "&euro;",
    num: "&#8364;",
    desc: "Euro Sign",
    category: "Currency",
  },
  {
    char: "£",
    name: "&pound;",
    num: "&#163;",
    desc: "Pound Sterling",
    category: "Currency",
  },
  {
    char: "¥",
    name: "&yen;",
    num: "&#165;",
    desc: "Yen Sign",
    category: "Currency",
  },
  {
    char: "¢",
    name: "&cent;",
    num: "&#162;",
    desc: "Cent Sign",
    category: "Currency",
  },
  {
    char: "₹",
    name: "&#8377;",
    num: "&#8377;",
    desc: "Indian Rupee",
    category: "Currency",
  },
  {
    char: "₿",
    name: "&#8383;",
    num: "&#8383;",
    desc: "Bitcoin",
    category: "Currency",
  },

  // Math
  {
    char: "×",
    name: "&times;",
    num: "&#215;",
    desc: "Multiplication Sign",
    category: "Math",
  },
  {
    char: "÷",
    name: "&divide;",
    num: "&#247;",
    desc: "Division Sign",
    category: "Math",
  },
  {
    char: "+",
    name: "&plus;",
    num: "&#43;",
    desc: "Plus Sign",
    category: "Math",
  },
  {
    char: "−",
    name: "&minus;",
    num: "&#8722;",
    desc: "Minus Sign",
    category: "Math",
  },
  {
    char: "±",
    name: "&plusmn;",
    num: "&#177;",
    desc: "Plus-Minus Sign",
    category: "Math",
  },
  {
    char: "≠",
    name: "&ne;",
    num: "&#8800;",
    desc: "Not Equal To",
    category: "Math",
  },
  {
    char: "≈",
    name: "&asymp;",
    num: "&#8776;",
    desc: "Almost Equal To",
    category: "Math",
  },
  {
    char: "∞",
    name: "&infin;",
    num: "&#8734;",
    desc: "Infinity",
    category: "Math",
  },
  {
    char: "√",
    name: "&radic;",
    num: "&#8730;",
    desc: "Square Root",
    category: "Math",
  },
  {
    char: "∑",
    name: "&sum;",
    num: "&#8721;",
    desc: "Summation",
    category: "Math",
  },
  {
    char: "∏",
    name: "&prod;",
    num: "&#8719;",
    desc: "Product",
    category: "Math",
  },
  {
    char: "π",
    name: "&pi;",
    num: "&#960;",
    desc: "Pi Symbol",
    category: "Math",
  },
  {
    char: "½",
    name: "&frac12;",
    num: "&#189;",
    desc: "Fraction One Half",
    category: "Math",
  },
  {
    char: "¼",
    name: "&frac14;",
    num: "&#188;",
    desc: "Fraction One Quarter",
    category: "Math",
  },
  {
    char: "¾",
    name: "&frac34;",
    num: "&#190;",
    desc: "Fraction Three Quarters",
    category: "Math",
  },
  {
    char: "°",
    name: "&deg;",
    num: "&#176;",
    desc: "Degree Sign",
    category: "Math",
  },
  {
    char: "∀",
    name: "&forall;",
    num: "&#8704;",
    desc: "For All",
    category: "Math",
  },
  {
    char: "∂",
    name: "&part;",
    num: "&#8706;",
    desc: "Partial Differential",
    category: "Math",
  },
  {
    char: "∃",
    name: "&exist;",
    num: "&#8707;",
    desc: "There Exists",
    category: "Math",
  },
  {
    char: "∅",
    name: "&empty;",
    num: "&#8709;",
    desc: "Empty Set",
    category: "Math",
  },
  {
    char: "∇",
    name: "&nabla;",
    num: "&#8711;",
    desc: "Nabla",
    category: "Math",
  },
  {
    char: "∈",
    name: "&isin;",
    num: "&#8712;",
    desc: "Element Of",
    category: "Math",
  },
  {
    char: "∉",
    name: "&notin;",
    num: "&#8713;",
    desc: "Not Element Of",
    category: "Math",
  },
  {
    char: "∠",
    name: "&ang;",
    num: "&#8736;",
    desc: "Angle",
    category: "Math",
  },

  // Arrows
  {
    char: "←",
    name: "&larr;",
    num: "&#8592;",
    desc: "Left Arrow",
    category: "Arrows",
  },
  {
    char: "→",
    name: "&rarr;",
    num: "&#8594;",
    desc: "Right Arrow",
    category: "Arrows",
  },
  {
    char: "↑",
    name: "&uarr;",
    num: "&#8593;",
    desc: "Up Arrow",
    category: "Arrows",
  },
  {
    char: "↓",
    name: "&darr;",
    num: "&#8595;",
    desc: "Down Arrow",
    category: "Arrows",
  },
  {
    char: "↔",
    name: "&harr;",
    num: "&#8596;",
    desc: "Left Right Arrow",
    category: "Arrows",
  },
  {
    char: "⇐",
    name: "&lArr;",
    num: "&#8656;",
    desc: "Left Double Arrow",
    category: "Arrows",
  },
  {
    char: "⇒",
    name: "&rArr;",
    num: "&#8658;",
    desc: "Right Double Arrow",
    category: "Arrows",
  },
  {
    char: "⇑",
    name: "&uArr;",
    num: "&#8657;",
    desc: "Up Double Arrow",
    category: "Arrows",
  },
  {
    char: "⇓",
    name: "&dArr;",
    num: "&#8659;",
    desc: "Down Double Arrow",
    category: "Arrows",
  },
  {
    char: "⇔",
    name: "&hArr;",
    num: "&#8660;",
    desc: "Left Right Double Arrow",
    category: "Arrows",
  },

  // Punctuation & Typography
  {
    char: "•",
    name: "&bull;",
    num: "&#8226;",
    desc: "Bullet",
    category: "Punctuation",
  },
  {
    char: "…",
    name: "&hellip;",
    num: "&#8230;",
    desc: "Horizontal Ellipsis",
    category: "Punctuation",
  },
  {
    char: "¶",
    name: "&para;",
    num: "&#182;",
    desc: "Paragraph Sign",
    category: "Punctuation",
  },
  {
    char: "§",
    name: "&sect;",
    num: "&#167;",
    desc: "Section Sign",
    category: "Punctuation",
  },
  {
    char: "—",
    name: "&mdash;",
    num: "&#8212;",
    desc: "Em Dash",
    category: "Punctuation",
  },
  {
    char: "–",
    name: "&ndash;",
    num: "&#8211;",
    desc: "En Dash",
    category: "Punctuation",
  },
  {
    char: "†",
    name: "&dagger;",
    num: "&#8224;",
    desc: "Dagger",
    category: "Punctuation",
  },
  {
    char: "‡",
    name: "&Dagger;",
    num: "&#8225;",
    desc: "Double Dagger",
    category: "Punctuation",
  },
  {
    char: "¡",
    name: "&iexcl;",
    num: "&#161;",
    desc: "Inverted Exclamation",
    category: "Punctuation",
  },
  {
    char: "¿",
    name: "&iquest;",
    num: "&#191;",
    desc: "Inverted Question",
    category: "Punctuation",
  },
  {
    char: "«",
    name: "&laquo;",
    num: "&#171;",
    desc: "Left Angle Quote",
    category: "Punctuation",
  },
  {
    char: "»",
    name: "&raquo;",
    num: "&#187;",
    desc: "Right Angle Quote",
    category: "Punctuation",
  },

  // Shapes & Symbols
  {
    char: "♥",
    name: "&hearts;",
    num: "&#9829;",
    desc: "Heart Suit",
    category: "Symbols",
  },
  {
    char: "♠",
    name: "&spades;",
    num: "&#9824;",
    desc: "Spade Suit",
    category: "Symbols",
  },
  {
    char: "♣",
    name: "&clubs;",
    num: "&#9827;",
    desc: "Club Suit",
    category: "Symbols",
  },
  {
    char: "♦",
    name: "&diams;",
    num: "&#9830;",
    desc: "Diamond Suit",
    category: "Symbols",
  },
  {
    char: "★",
    name: "&#9733;",
    num: "&#9733;",
    desc: "Black Star",
    category: "Symbols",
  },
  {
    char: "☀",
    name: "&#9728;",
    num: "&#9728;",
    desc: "Sun",
    category: "Symbols",
  },
  {
    char: "☁",
    name: "&#9729;",
    num: "&#9729;",
    desc: "Cloud",
    category: "Symbols",
  },
  {
    char: "☂",
    name: "&#9730;",
    num: "&#9730;",
    desc: "Umbrella",
    category: "Symbols",
  },
  {
    char: "✓",
    name: "&#10003;",
    num: "&#10003;",
    desc: "Check Mark",
    category: "Symbols",
  },
  {
    char: "✗",
    name: "&#10007;",
    num: "&#10007;",
    desc: "Ballot X",
    category: "Symbols",
  },
  {
    char: "⚠",
    name: "&#9888;",
    num: "&#9888;",
    desc: "Warning Sign",
    category: "Symbols",
  },
  {
    char: "⚡",
    name: "&#9889;",
    num: "&#9889;",
    desc: "High Voltage",
    category: "Symbols",
  },
  {
    char: "⛔",
    name: "&#9940;",
    num: "&#9940;",
    desc: "No Entry",
    category: "Symbols",
  },

  // Greek Letters
  {
    char: "Α",
    name: "&Alpha;",
    num: "&#913;",
    desc: "Capital Alpha",
    category: "Greek",
  },
  {
    char: "Β",
    name: "&Beta;",
    num: "&#914;",
    desc: "Capital Beta",
    category: "Greek",
  },
  {
    char: "Γ",
    name: "&Gamma;",
    num: "&#915;",
    desc: "Capital Gamma",
    category: "Greek",
  },
  {
    char: "Δ",
    name: "&Delta;",
    num: "&#916;",
    desc: "Capital Delta",
    category: "Greek",
  },
  {
    char: "Θ",
    name: "&Theta;",
    num: "&#920;",
    desc: "Capital Theta",
    category: "Greek",
  },
  {
    char: "Λ",
    name: "&Lambda;",
    num: "&#923;",
    desc: "Capital Lambda",
    category: "Greek",
  },
  {
    char: "Σ",
    name: "&Sigma;",
    num: "&#931;",
    desc: "Capital Sigma",
    category: "Greek",
  },
  {
    char: "Φ",
    name: "&Phi;",
    num: "&#934;",
    desc: "Capital Phi",
    category: "Greek",
  },
  {
    char: "Ω",
    name: "&Omega;",
    num: "&#937;",
    desc: "Capital Omega",
    category: "Greek",
  },
  {
    char: "α",
    name: "&alpha;",
    num: "&#945;",
    desc: "Small Alpha",
    category: "Greek",
  },
  {
    char: "β",
    name: "&beta;",
    num: "&#946;",
    desc: "Small Beta",
    category: "Greek",
  },
  {
    char: "γ",
    name: "&gamma;",
    num: "&#947;",
    desc: "Small Gamma",
    category: "Greek",
  },
  {
    char: "δ",
    name: "&delta;",
    num: "&#948;",
    desc: "Small Delta",
    category: "Greek",
  },
  {
    char: "θ",
    name: "&theta;",
    num: "&#952;",
    desc: "Small Theta",
    category: "Greek",
  },
  {
    char: "λ",
    name: "&lambda;",
    num: "&#955;",
    desc: "Small Lambda",
    category: "Greek",
  },
  {
    char: "μ",
    name: "&mu;",
    num: "&#181;",
    desc: "Small Mu",
    category: "Greek",
  },
  {
    char: "π",
    name: "&pi;",
    num: "&#960;",
    desc: "Small Pi",
    category: "Greek",
  },
  {
    char: "σ",
    name: "&sigma;",
    num: "&#963;",
    desc: "Small Sigma",
    category: "Greek",
  },
  {
    char: "φ",
    name: "&phi;",
    num: "&#966;",
    desc: "Small Phi",
    category: "Greek",
  },
  {
    char: "ω",
    name: "&omega;",
    num: "&#969;",
    desc: "Small Omega",
    category: "Greek",
  },

  // Food & Drink
  {
    char: "🍎",
    name: "&#127822;",
    num: "&#127822;",
    desc: "Red Apple",
    category: "Food",
  },
  {
    char: "🥦",
    name: "&#129382;",
    num: "&#129382;",
    desc: "Broccoli",
    category: "Food",
  },
  {
    char: "🥕",
    name: "&#129365;",
    num: "&#129365;",
    desc: "Carrot",
    category: "Food",
  },
  {
    char: "🌽",
    name: "&#127805;",
    num: "&#127805;",
    desc: "Ear of Corn",
    category: "Food",
  },
  {
    char: "🍔",
    name: "&#127828;",
    num: "&#127828;",
    desc: "Hamburger",
    category: "Food",
  },
  {
    char: "🍕",
    name: "&#127829;",
    num: "&#127829;",
    desc: "Pizza",
    category: "Food",
  },
  {
    char: "🍗",
    name: "&#127831;",
    num: "&#127831;",
    desc: "Poultry Leg",
    category: "Food",
  },
  {
    char: "🥩",
    name: "&#129385;",
    num: "&#129385;",
    desc: "Cut of Meat",
    category: "Food",
  },
  {
    char: "☕",
    name: "&#9749;",
    num: "&#9749;",
    desc: "Hot Beverage",
    category: "Food",
  },
  {
    char: "🍺",
    name: "&#127866;",
    num: "&#127866;",
    desc: "Beer Mug",
    category: "Food",
  },

  // Ecommerce & Shopping
  {
    char: "🛒",
    name: "&#128722;",
    num: "&#128722;",
    desc: "Shopping Cart",
    category: "Ecommerce",
  },
  {
    char: "🛍️",
    name: "&#128717;",
    num: "&#128717;",
    desc: "Shopping Bags",
    category: "Ecommerce",
  },
  {
    char: "💳",
    name: "&#128179;",
    num: "&#128179;",
    desc: "Credit Card",
    category: "Ecommerce",
  },
  {
    char: "💰",
    name: "&#128176;",
    num: "&#128176;",
    desc: "Money Bag",
    category: "Ecommerce",
  },
  {
    char: "📦",
    name: "&#128230;",
    num: "&#128230;",
    desc: "Package",
    category: "Ecommerce",
  },
  {
    char: "🏷️",
    name: "&#127991;",
    num: "&#127991;",
    desc: "Label",
    category: "Ecommerce",
  },

  // Travel & Transport
  {
    char: "✈",
    name: "&#9992;",
    num: "&#9992;",
    desc: "Airplane",
    category: "Travel",
  },
  {
    char: "🚗",
    name: "&#128663;",
    num: "&#128663;",
    desc: "Automobile",
    category: "Travel",
  },
  {
    char: "🚀",
    name: "&#128640;",
    num: "&#128640;",
    desc: "Rocket",
    category: "Travel",
  },
  {
    char: "🚢",
    name: "&#128674;",
    num: "&#128674;",
    desc: "Ship",
    category: "Travel",
  },
  {
    char: "🚲",
    name: "&#128690;",
    num: "&#128690;",
    desc: "Bicycle",
    category: "Travel",
  },
  {
    char: "🚦",
    name: "&#128678;",
    num: "&#128678;",
    desc: "Vertical Traffic Light",
    category: "Travel",
  },
  {
    char: "🗺️",
    name: "&#128506;",
    num: "&#128506;",
    desc: "World Map",
    category: "Travel",
  },
  {
    char: "🏖️",
    name: "&#127958;",
    num: "&#127958;",
    desc: "Beach with Umbrella",
    category: "Travel",
  },

  // Office & Tech
  {
    char: "💻",
    name: "&#128187;",
    num: "&#128187;",
    desc: "Laptop",
    category: "Office",
  },
  {
    char: "🖥️",
    name: "&#128421;",
    num: "&#128421;",
    desc: "Desktop Computer",
    category: "Office",
  },
  {
    char: "🖨️",
    name: "&#128424;",
    num: "&#128424;",
    desc: "Printer",
    category: "Office",
  },
  {
    char: "📱",
    name: "&#128241;",
    num: "&#128241;",
    desc: "Mobile Phone",
    category: "Office",
  },
  {
    char: "📞",
    name: "&#128222;",
    num: "&#128222;",
    desc: "Telephone",
    category: "Office",
  },
  {
    char: "📅",
    name: "&#128197;",
    num: "&#128197;",
    desc: "Calendar",
    category: "Office",
  },
  {
    char: "📎",
    name: "&#128206;",
    num: "&#128206;",
    desc: "Paperclip",
    category: "Office",
  },
  {
    char: "📊",
    name: "&#128202;",
    num: "&#128202;",
    desc: "Bar Chart",
    category: "Office",
  },
  {
    char: "📁",
    name: "&#128193;",
    num: "&#128193;",
    desc: "File Folder",
    category: "Office",
  },
  {
    char: "🔒",
    name: "&#128274;",
    num: "&#128274;",
    desc: "Lock",
    category: "Office",
  },

  // Nature & Animals
  {
    char: "🌲",
    name: "&#127794;",
    num: "&#127794;",
    desc: "Evergreen Tree",
    category: "Nature",
  },
  {
    char: "🌵",
    name: "&#127797;",
    num: "&#127797;",
    desc: "Cactus",
    category: "Nature",
  },
  {
    char: "🌺",
    name: "&#127802;",
    num: "&#127802;",
    desc: "Hibiscus",
    category: "Nature",
  },
  {
    char: "🌻",
    name: "&#127803;",
    num: "&#127803;",
    desc: "Sunflower",
    category: "Nature",
  },
  {
    char: "🐶",
    name: "&#128054;",
    num: "&#128054;",
    desc: "Dog Face",
    category: "Nature",
  },
  {
    char: "🐱",
    name: "&#128049;",
    num: "&#128049;",
    desc: "Cat Face",
    category: "Nature",
  },
  {
    char: "🦄",
    name: "&#129412;",
    num: "&#129412;",
    desc: "Unicorn",
    category: "Nature",
  },
  {
    char: "🦋",
    name: "&#129419;",
    num: "&#129419;",
    desc: "Butterfly",
    category: "Nature",
  },

  // Weather
  {
    char: "❄",
    name: "&#10052;",
    num: "&#10052;",
    desc: "Snowflake",
    category: "Weather",
  },
  {
    char: "⚡",
    name: "&#9889;",
    num: "&#9889;",
    desc: "High Voltage",
    category: "Weather",
  },
  {
    char: "🌈",
    name: "&#127752;",
    num: "&#127752;",
    desc: "Rainbow",
    category: "Weather",
  },
  {
    char: "🔥",
    name: "&#128293;",
    num: "&#128293;",
    desc: "Fire",
    category: "Weather",
  },
  {
    char: "💧",
    name: "&#128167;",
    num: "&#128167;",
    desc: "Droplet",
    category: "Weather",
  },

  // Emoticons
  {
    char: "😀",
    name: "&#128512;",
    num: "&#128512;",
    desc: "Grinning Face",
    category: "Emoticons",
  },
  {
    char: "😂",
    name: "&#128514;",
    num: "&#128514;",
    desc: "Tears of Joy",
    category: "Emoticons",
  },
  {
    char: "😍",
    name: "&#128525;",
    num: "&#128525;",
    desc: "Heart Eyes",
    category: "Emoticons",
  },
  {
    char: "😎",
    name: "&#128526;",
    num: "&#128526;",
    desc: "Sunglasses",
    category: "Emoticons",
  },
  {
    char: "🤔",
    name: "&#129300;",
    num: "&#129300;",
    desc: "Thinking Face",
    category: "Emoticons",
  },
  {
    char: "👍",
    name: "&#128077;",
    num: "&#128077;",
    desc: "Thumbs Up",
    category: "Emoticons",
  },
  {
    char: "👏",
    name: "&#128079;",
    num: "&#128079;",
    desc: "Clapping Hands",
    category: "Emoticons",
  },
  {
    char: "🙏",
    name: "&#128591;",
    num: "&#128591;",
    desc: "Folded Hands",
    category: "Emoticons",
  },
  {
    char: "🎉",
    name: "&#127881;",
    num: "&#127881;",
    desc: "Party Popper",
    category: "Emoticons",
  },
  {
    char: "💡",
    name: "&#128161;",
    num: "&#128161;",
    desc: "Light Bulb",
    category: "Emoticons",
  },

  // Music
  {
    char: "♩",
    name: "&#9833;",
    num: "&#9833;",
    desc: "Quarter Note",
    category: "Music",
  },
  {
    char: "♪",
    name: "&#9834;",
    num: "&#9834;",
    desc: "Eighth Note",
    category: "Music",
  },
  {
    char: "♫",
    name: "&#9835;",
    num: "&#9835;",
    desc: "Beamed Eighth Notes",
    category: "Music",
  },
  {
    char: "♬",
    name: "&#9836;",
    num: "&#9836;",
    desc: "Beamed Sixteenth Notes",
    category: "Music",
  },
  {
    char: "♭",
    name: "&#9837;",
    num: "&#9837;",
    desc: "Music Flat Sign",
    category: "Music",
  },
  {
    char: "♮",
    name: "&#9838;",
    num: "&#9838;",
    desc: "Music Natural Sign",
    category: "Music",
  },
  {
    char: "♯",
    name: "&#9839;",
    num: "&#9839;",
    desc: "Music Sharp Sign",
    category: "Music",
  },

  // Astrology (Zodiac)
  {
    char: "♈",
    name: "&#9800;",
    num: "&#9800;",
    desc: "Aries",
    category: "Astrology",
  },
  {
    char: "♉",
    name: "&#9801;",
    num: "&#9801;",
    desc: "Taurus",
    category: "Astrology",
  },
  {
    char: "♊",
    name: "&#9802;",
    num: "&#9802;",
    desc: "Gemini",
    category: "Astrology",
  },
  {
    char: "♋",
    name: "&#9803;",
    num: "&#9803;",
    desc: "Cancer",
    category: "Astrology",
  },
  {
    char: "♌",
    name: "&#9804;",
    num: "&#9804;",
    desc: "Leo",
    category: "Astrology",
  },
  {
    char: "♍",
    name: "&#9805;",
    num: "&#9805;",
    desc: "Virgo",
    category: "Astrology",
  },
  {
    char: "♎",
    name: "&#9806;",
    num: "&#9806;",
    desc: "Libra",
    category: "Astrology",
  },
  {
    char: "♏",
    name: "&#9807;",
    num: "&#9807;",
    desc: "Scorpio",
    category: "Astrology",
  },
  {
    char: "♐",
    name: "&#9808;",
    num: "&#9808;",
    desc: "Sagittarius",
    category: "Astrology",
  },
  {
    char: "♑",
    name: "&#9809;",
    num: "&#9809;",
    desc: "Capricorn",
    category: "Astrology",
  },
  {
    char: "♒",
    name: "&#9810;",
    num: "&#9810;",
    desc: "Aquarius",
    category: "Astrology",
  },
  {
    char: "♓",
    name: "&#9811;",
    num: "&#9811;",
    desc: "Pisces",
    category: "Astrology",
  },

  // Chess
  {
    char: "♔",
    name: "&#9812;",
    num: "&#9812;",
    desc: "White King",
    category: "Chess",
  },
  {
    char: "♕",
    name: "&#9813;",
    num: "&#9813;",
    desc: "White Queen",
    category: "Chess",
  },
  {
    char: "♖",
    name: "&#9814;",
    num: "&#9814;",
    desc: "White Rook",
    category: "Chess",
  },
  {
    char: "♗",
    name: "&#9815;",
    num: "&#9815;",
    desc: "White Bishop",
    category: "Chess",
  },
  {
    char: "♘",
    name: "&#9816;",
    num: "&#9816;",
    desc: "White Knight",
    category: "Chess",
  },
  {
    char: "♙",
    name: "&#9817;",
    num: "&#9817;",
    desc: "White Pawn",
    category: "Chess",
  },
  {
    char: "♚",
    name: "&#9818;",
    num: "&#9818;",
    desc: "Black King",
    category: "Chess",
  },
  {
    char: "♛",
    name: "&#9819;",
    num: "&#9819;",
    desc: "Black Queen",
    category: "Chess",
  },
  {
    char: "♜",
    name: "&#9820;",
    num: "&#9820;",
    desc: "Black Rook",
    category: "Chess",
  },
  {
    char: "♝",
    name: "&#9821;",
    num: "&#9821;",
    desc: "Black Bishop",
    category: "Chess",
  },
  {
    char: "♞",
    name: "&#9822;",
    num: "&#9822;",
    desc: "Black Knight",
    category: "Chess",
  },
  {
    char: "♟",
    name: "&#9823;",
    num: "&#9823;",
    desc: "Black Pawn",
    category: "Chess",
  },
];
